<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img src="images/anze-product.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>人保5至6类个人意外险（高空版）</h2>
					<div style="color: red">5-6类职业 | 1人起保 | 可保高空</div>
					<p>
						① 5-6类职业，可保高空
						<br />
						② 最高可保50万
						<br />
						③ 1人起保，无需营业执照
						<br />
					</p>
					<el-button size="medium" type="warning" @click.native="handleInsure">立即投保</el-button>
					<br />
					<el-button
						:loading="isDownLoading"
						icon="el-icon-download"
						size="medium"
						style="margin-top: 25px"
						type="text"
						@click.native="handleDownLoad">
						下载人保5至6类险职业类别表
					</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<avue-crud ref="plan" :data="dataPlan" :option="optionPlan" :span-method="spanMethodPlan"></avue-crud>
				</el-card>
				<!--        <el-card header="伤残比例">-->
				<!--          <avue-crud ref="crud"-->
				<!--                     :data="dataBenefit"-->
				<!--                     :option="optionBenefit">-->
				<!--          </avue-crud>-->
				<!--        </el-card>-->
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="20">
						<ul>
							<li v-for="qa in dataQA" :key="qa.question">
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ qa.question }}</span>
								</div>
								<p></p>
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>
									<span style="white-space: pre-wrap" v-html="qa.answer"></span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="20">
						<h3>一、产品基本信息</h3>
						<div style="white-space: pre-line">
							1、被保险人须符合如下要求: (1) 被保险人年龄范围 18 周岁（含）-65
							周岁（含），外籍人士及港澳台人士不支持投保； (2) 身体健康的，在中国大陆常住或生活的人员； (3)
							根据《中国人民财产保险股份有限公司意外伤害保险职业分类表》，被保险人职业类别限5-6类，其他职业不可投保。
							2、投保人须符合如下要求: (1)
							投保人应对被保险人具有可保利益，可以为被保险人本人或被保险人的父母、配偶、子女投保； (2)
							年龄18周岁的具有完全民事行为能力的自然人可作为投保人。 3、身故受益人：本产品受益人为法定受益人。
							4、本产品每人限购一份，多投无效。 5、保险期间：1年。 6、等待期：无等待期。
							7、生效日：本产品自投保之日起，最早
							<span class="red-bold">T+2日零时</span>
							生效。 8、赔付比例：
							<span class="red-bold">
								在保险期间内，被保险人遭受意外伤害事故，保险人就被保险人自事故发生之日起实际支出的按照当地(保单签发地)
								社会医疗保险主管部门规定可报销的、必要、合理的医疗费用，每次免赔 100 元，剩余部分按
								80%赔付；未参加社会医疗保险身份就诊或结算的，对于事故发生之日起实际支出的按照当地(保单签发地)社会医疗保险主管部门规定可报销的、必要、合理的医疗费用，每次免赔
								300 元，剩余部分按
								60%赔付；并且，保险期间届满被保险人治疗仍未结束的，保险人所负保险责任期限可按下列约定延长：门诊急诊治疗者，自保险期间届满次日起计算，以门诊急诊延长
								15 日为限；保险期间届满被保险人仍在住院治疗的，自保险期间届满次日起计算，至出院之日止，最长以 90
								日为限。
							</span>
							9、本产品为一年期产品，不保证续保。 10、
							<span class="red-bold">
								退保规则：若投保人申请解除保险合同，保险人支持退保并退还本保险合同的现金价值，按下述公式计算现金价值：
							</span>
							<br />
							<span class="red-bold">
								现金价值=净保费×（1-m/n），其中，m为已生效天数，n为保险期间的天数，经过日期不足一日的按一日计算。
							</span>
						</div>

						<span class="red-bold"></span>

						<el-divider></el-divider>
						<h3>二、保险机构信息</h3>
						<div style="white-space: pre-line">
							1、承保公司、销售主体：本产品由中国人民财产保险股份有限公司（简称中国人保财险）承保，目前中国人保财险在北京、上海、天津、重庆、河北、陕西、内蒙古、山西、辽宁、吉林、黑龙江、江苏、安徽、浙江、福建、江西、山东、湖北、湖南、河南、广东、广西、海南、四川、云南、贵州、甘肃、宁夏、青海、西藏、新疆、大连、青岛、宁波、厦门、杭州、广州、深圳设有分支机构。本产品由博维保险经纪有限公司广东分公司代理销售。
							2、销售范围：本产品的销售范围为全国。 3、条款适用：本产品适用条款为
							4、保单形式：网上投保为您提供电子保单，根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式，电子保单与纸质保单具有同等法律效力。你可以登录中国人保财险官网“http://www.epicc.com.cn”或关注“中国人保财险”微信公众号自助查询，对电子保单的真实性进行验证。
							5、发票形式：本产品仅提供电子发票，电子发票效力等同于纸质发票，报销可将电子发票打印后直接报销。
							6、如实告知：投保时，投保人应如实填写投保信息，并如实告知被保人的健康及职业状况。如未履行如实告知义务的，保险公司有权依法解除保险合同，并对合同解除前发生的保险事故不承担保险责任。
							7、客户授权：如您投保此保险，视为您本人授权中国人保财险和博维保险经纪有限公司广东分公司出于提升保险服务质量之目的，合法的从任何单位、组织和个人获取您本人有关的资料和证明，作为审核投保、处理理赔及提供与本保险有关其他服务的依据。
							8、信息安全：我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。
							9、公司偿付能力信息公开披露查询地址：
							<el-link href="https://www.picc.com/xwzx/gkxx/ndxx/" type="primary">公司偿付能力信息公开披露查询</el-link>
							。 10、7*24小时服务热线/投诉热线：4006-366-366。
						</div>
						<h3>三、特约约定</h3>
						<div style="white-space: pre-line">
							1、每人
							<span class="red-bold">仅限投保一份，多投无效。</span>
							2、本保单被保险人年龄范围18周岁-65周岁，外籍人士及港澳台人士不支持投保。 3、
							<span class="red-bold">
								被保险人职业类别：本保单仅承保《中国人民财产保险股份有限公司意外伤害保险职业分类表》中5-6类职业人员，其他职业类别人员不在本保险合同的投保范围。被保险人职业类别以出险时的行为状态确定，从事不可保职业的人员为本保险不可保对象，本公司不承担保险责任；非不可保职业人员但从事不可保职业相关活动时发生的事故也不属于保险责任范围。其中下列职业被保险人不予投保：石材加工制造、矿业、采石业、炸药业、危险化工行业、直升机飞行人、飞行训练人、楼宇拆除工人爆破工作人员、潜水工作人员、火药、炸药制造人员、有关高压电工作人员、石棉瓦工作人员、特技演员、驯兽师、空中飞人、走钢丝人员、动物园驯兽师、保镖、炸药处理警察、防爆警察、警校学生、拳击运动员、各类赛车手、跳伞、登山运动人员、现役军人、煤矿业、油矿业。
							</span>
							4、意外医疗费用补偿责任：
							（1）医院范围：本保单意外医疗相关保障指定就诊医院为中华人民共和国境内(不包括香港、澳门、台湾地区)
							<span class="red-bold">二级或二级以上公立医院</span>
							，且应符合下列所有条件:1)拥有合法经营执照；2)设立的主要目的为向受伤者和患病者提供留院治疗和护理服务；3)有合格的医生和护士提供全日二十四小时的医疗和护理服务；4)非主要作为康复医院、诊所、护理、疗养、戒酒、戒毒或类似的医疗机构。
							<span class="red-bold">
								但不包括以下医院：1）北京市的平谷区、密云区、怀柔区所有医院；2）江苏省的徐州市、南通市、连云港市所有医院；3）天津市的滨海、静海地区所有医院；4）辽宁省的铁岭市所有医院、辽宁中医药大学附属第二医院、中国人民解放军第二0五医院、辽宁省中医医院、营口市所有医院；5）吉林省的长春市、四平市所有医院、吉林省中医医院、吉林通化市人民医院、抚松县中医院；6）黑龙江省佳木斯市富锦市中心医院、中医医院、鸡西市所有医院；7）河北省的青县、青龙县、东光县、三河市、承德市兴隆县、廊坊市固安县所有医院、邯郸市馆陶县人民医院、南皮县中医医院；8）河南省的信阳市、洛阳市、郑州市、开封市、新乡市、商丘市、焦作市、安阳市黄县所有医院、通许县中医院；9）山东省的禹城市、栖霞市、莱州市、德州禹城、潍坊市高密县的所有医院、滨州市中心医院、青岛市即墨区中医医院、莱阳市中医医院、济宁市金乡县人民医院、鱼台县人民医院、荣成市中医院、烟台市中医院、富顺县中医院、曹县人民医院、济南市长清区人民医院；10）山西省运城市、阳泉市所有医院、太原市迎泽区中医院；11）四川省的宜宾市、内江市、雅安市所有医院、邛崃市医疗中心医院；12）内蒙古的扎兰屯市、赤峰市所有医院；13）广东省的湛江市第二中医医院、茂名市电白区人民医院；14）湖南省的衡阳市中医正骨医院、衡阳市中心医院；15）安徽省毫州市所有医院；16）甘肃省民勤县人民医院、庆阳市中医医院；17）福建南平的所有医院；18）所有私营社保定点医院。请注意：被保险人在上述医院进行治疗的保险人均不予以理赔，建议您去其他区域的
								<span class="red-bold">二级或二级以上公立医院</span>
								就医。
							</span>
							（2）赔付标准：
							<span class="red-bold">
								在保险期间内，对于被保险人遭受意外伤害之日起实际支出的当地(保单签发地)社会医疗保险主管部门规定可报销的、必要、合理的医疗费用，在扣除社会基本医疗保险、公费医疗已经补偿或给付部分后，保险人按每次事故绝对免赔额100元，对其余额按80%比例给付；若被保险人未参加社会医疗保险身份就诊或结算的，对于事故发生之日起实际支出的按照当地(保单签发地)社会医疗保险主管部门规定可报销的、必要、合理的医疗费用，保险人扣除每次事故绝对免赔额300元后，对其余额按60%比例给付。保险期间届满被保险人治疗仍未结束的，保险人所负保险责任期限可按下列约定延长：门诊急诊治疗者，自保险期间届满次日起计算，以门诊急诊延长15日为限；保险期间届满被保险人仍在住院治疗的，自保险期间届满次日起计算，至出院之日止，最长以90日为限。
							</span>
							5、本产品意外伤害医疗保障，
							<span class="red-bold">
								不承担普通针刺治疗、针炙治疗、红外线治疗、可见光治疗、紫外线治疗、激光疗法、光敏疗法、直流电治疗、低频脉冲电治疗、中频脉冲电治疗、超短波短波治疗、微波治疗、射频电疗、静电治疗、空气负离子治疗、超声波治疗、电子生物反馈疗法、磁疗、水疗、蜡疗、泥疗、牵引、气压治疗、冷疗、电按摩、场效应治疗、中频脉冲电治疗、穴位贴敷治疗、中医定向透药疗法等中医治疗、理疗行为产生的医疗费用。
							</span>
							6、意外住院津贴责任：意外住院津贴责任100元/天，
							<span class="red-bold">单次最高给付津贴日数30天，总给付日数180天，免赔天数0天。</span>
							7、在本保单可承保高空作业，
							<span class="red-bold">
								被保险人若从事高处作业【凡在坠落高度基准面2m以上(含2m)有可能坠落的高处进行的作业，高处作业以《高处作业分级标准》(中华人民共和国国家标准GB/T3608-2008)中的定义为准】，须按照相关行业安全管理规定取得由应急管理部门颁发《高处作业操作证》，否则发生死亡或伤残事故，保险人按照保单约定应承担保险责任的
								75%计算赔偿金额。
							</span>
							8、被保险人
							<span class="red-bold">
								如系涉及特种行业岗位，根据《中华人民共和国安全生产法》之规定，必须持有国家安全生产监管局签发的特种作业操作证（不含高处作业操作证），或国家质量技术监督局签发的特种设备作业证上岗，否则本保险公司对可能发生的人身伤亡及医疗费用不承担赔偿责任。
							</span>
							四、责任免除 *《中国人民财产保险股份有限公司意外伤害保险（互联网专属）条款》责任免除*
							<span class="red-bold">
								因下列情形之一，导致被保险人意外身故或意外伤残的，保险人不承担给付保险金的责任：
							</span>
							<span class="red-bold">
								（1）投保人对被保险人的故意杀害、故意伤害；
								（2）被保险人故意自伤或自杀，但被保险人自杀时为无民事行为能力人的除外；
								（3）被保险人因挑衅或故意行为而导致的打斗、被袭击或被谋杀；
								（4）被保险人未遵医嘱服用、涂用、注射药物，但按使用说明的规定使用非处方药不在此限；
								（5）被保险人受酒精、毒品、管制药物的影响，但遵医嘱使用药物的情形不在此限；
								（6）疾病，包括但不限于高原反应、中暑、猝死； （7）非因意外伤害导致的细菌、病毒或其他病原体导致的感染；
								（8）过敏及由过敏引发的变态反应性疾病；
								（9）任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射；
								（10）战争、军事冲突、暴乱或武装叛乱、恐怖袭击； （11）被保险人故意犯罪或抗拒依法采取的刑事强制措施；
								（12）被保险人存在精神和行为障碍（以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类（ICD-10）》为准）；
								（13）被保险人接受包括美容、整容、整形手术在内的任何医疗行为而造成的意外；
								（14）被保险人妊娠、流产、分娩； （15）被保险人感染艾滋病病毒或患艾滋病（见释义）；
								（16）被保险人从事高风险运动（见释义），但被保险人作为专业运动员从事其专业运动不在此限；
								（17）被保险人酒后驾驶（见释义）、无合法有效驾驶证（见释义）驾驶或驾驶无合法有效行驶证（见释义）的机动交通工具。
							</span>

							*《中国人民财产保险股份有限公司附加意外伤害医疗保险A款（互联网专属）条款》责任免除*
							<span class="red-bold">
								1. 因下列情形之一，导致被保险人支出医疗费用的，保险人不承担给付保险金责任：
								（1）投保人对被保险人的故意杀害、故意伤害；
								（2）被保险人故意自伤或自杀，但被保险人自杀时为无民事行为能力人的除外；
								（3）被保险人因挑衅或故意行为而导致的打斗、被袭击或被谋杀； （4）被保险人妊娠、流产、分娩；
								（5）被保险人接受包括美容、整容、整形手术在内的任何医疗行为而造成的意外；
								（6）被保险人未遵医嘱服用、涂用、注射药物，但按使用说明的规定使用非处方药不在此限；
								（7）被保险人受酒精、毒品、管制药物的影响，但遵医嘱使用药物的情形不在此限；
								（8）任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射；
								（9）战争、军事冲突、暴乱或武装叛乱、恐怖袭击； （10）被保险人故意犯罪或抗拒依法采取的刑事强制措施；
								（11）被保险人存在精神和行为障碍（以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类（ICD-10）》为准）；
								（12）被保险人感染艾滋病病毒或患艾滋病（见释义）；
								（13）被保险人从事高风险运动（见释义），但被保险人作为专业运动员从事其专业运动不在此限；
								（14）被保险人酒后驾驶（见释义）、无有效驾驶证（见释义）驾驶或驾驶无有效行驶证（见释义）的机动交通工具；
								（15）疾病，包括但不限于高原反应、中暑、猝死（见释义）；
								（16）非因意外伤害导致的细菌、病毒或其他病原体感染； （17）过敏及由过敏引发的变态反应性疾病；
								（18）被保险人非因意外伤害而进行的整容、整形手术，以及因任何原因进行的美容；
								（19）被保险人非因意外伤害而进行的牙科治疗或手术、视力矫正、因矫正视力而作的眼科验光检查，以及任何原因导致的牙齿修复或牙齿整形、安装及购买残疾用具（如轮椅、假肢、假眼、假牙或者助听器等）；
								（20）被保险人进行一般身体检查、疗养、特别护理、静养、康复性治疗、物理治疗、心理治疗或预防性治疗；
								（21）被保险人在获得被保资格前已有残疾的治疗和康复； （22）被保险人在家自设病床治疗；
								（23）被保险人不符合入院标准住院、挂床住院（见释义）或应当出院但拒不出院而造成的延长住院。
							</span>
							<span class="red-bold">2. 对于本附加险合同载明的免赔额，保险人不承担给付保险金的责任。</span>

							*《中国人民财产保险股份有限公司附加意外伤害住院津贴保险A款（互联网专属）条款》责任免除*
							<span class="red-bold">
								1、因下列情形造成被保险人住院治疗的，保险人不承担给付保险金的责任： （1）
								投保人对被保险人的故意杀害、故意伤害； （2）
								被保险人故意自伤或自杀，但被保险人自杀时为无民事行为能力人的除外； （3）
								被保险人因挑衅或故意行为而导致的打斗、被袭击或被谋杀； （4）
								被保险人接受包括美容、整容、整形手术在内的任何医疗行为而造成的意外； （5）
								被保险人未遵医嘱服用、涂用、注射药物，但按使用说明的规定使用非处方药不在此限； （6）
								被保险人受酒精、毒品、管制药物的影响，但遵医嘱使用药物的情形不在此限； （7）
								任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射； （8）
								战争、军事冲突、暴乱或武装叛乱、恐怖袭击； （9） 被保险人故意犯罪或抗拒依法采取的刑事强制措施； （10）
								被保险人存在精神和行为障碍（以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类（ICD-10）》为准）；
								（11） 被保险人从事高风险运动（见释义），但被保险人作为专业运动员从事其专业运动不在此限； （12）
								被保险人酒后驾驶（见释义）、无合法有效驾驶证（见释义）驾驶或驾驶无合法有效行驶证（见释义）的机动交通工具；
								（13） 疾病，包括但不限于高原反应、中暑、猝死（见释义）； （14）
								非因意外伤害导致的细菌、病毒或其他病原体导致的感染； （15） 过敏及由过敏引发的变态反应性疾病； （16）
								被保险人非因意外伤害而进行的整容、整形手术，以及因任何原因进行的美容； （17）
								被保险人非因意外伤害而进行的牙科治疗或手术、视力矫正、因矫正视力而作的眼科验光检查，以及任何原因导致的牙齿修复或牙齿整形、安装及购买残疾用具（如轮椅、假肢、假眼、假牙或者助听器等）；
								（18） 被保险人进行一般身体检查、疗养、特别护理、静养、康复性治疗、物理治疗、心理治疗或预防性治疗；
								（19） 被保险人妊娠、流产、分娩； （20） 被保险人在投保前已有残疾的治疗和康复。
								2、对于以下情形，保险人也不承担给付保险金的责任： （1）
								被保险人在家自设病床治疗，或在门诊观察室、急诊观察室、其他非正式病房、联合病房的治疗； （2）
								被保险人不符合入院标准住院、挂床住院（见释义）或住院病人应当出院但拒不出院而造成的延长的住院日数。
								3、对于按本附加险合同载明的免赔日数计算出的免赔金额，保险人不承担赔偿责任。
							</span>
						</div>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {currentYYYYmmdd} from '@/util/date'
import {handleDownCategoryFile} from '@/util/util'
import {
	optionAddFeeRate,
	optionBenefit,
	optionPlanYgjc,
	optionPremium,
	optionPremiumRestrict,
} from '@/const/crud/insurance/productDetail'

export default {
	name: 'renbao-29',
	props: {
		productId: {
			type: String | Number,
			required: true,
		},
	},
	data: function () {
		return {
			currentStep: '0',
			optionPlan: optionPlanYgjc,
			optionPremium: optionPremium,
			optionPremiumRestrict: optionPremiumRestrict,
			optionBenefit: optionBenefit,
			optionAddFeeRate: optionAddFeeRate,
			dataPlan: [
				{
					insuredItem: '身故/伤残',
					plan1: '10万',
					plan2: '20万',
					plan3: '30万',
					plan4: '50万',
				},
				{
					insuredItem: '意外医疗费用补偿',
					plan1: '1万',
					plan2: '2万',
					plan3: '3万',
					plan4: '5万',
				},
				{
					insuredItem: '意外医疗费用补偿',
					plan1: `经社保报销的，每次免赔100元，剩余部分按80%赔付；<br/>未经社保报销的，每次免赔300元，剩余部分按60%赔付`,
				},
				{
					insuredItem: '意外住院津贴',
					plan1: '100元/天',
					plan2: '100元/天',
					plan3: '100元/天',
					plan4: '100元/天',
				},
				{
					insuredItem: '意外住院津贴',
					plan1: '0免赔天数，每次以30天为限，累计以180天为限',
				},
				{
					insuredItem: '保费（元/年）',
					plan1: '300',
					plan2: '600',
					plan3: '900',
					plan4: '1500',
				},
			],
			dataQA: [
				{
					question: '多少人起可以投保？',
					answer: '一人起保，无需营业执照。本保险为个人意外伤害保险，每份保单仅承保一人，每人限投一份。',
				},
				{
					question: '对被保险人年龄限制是怎么样的？',
					answer: '被保险人投保年龄为18-65周岁。',
				},
				{
					question: '意外的定义是什么？',
					answer: '意外伤害是指以外来的、突发的、非本意的和非疾病的客观事件为直接且单独的原因致使身体受到的伤害。',
				},
				{
					question: '怎么投保？怎么支付？',
					answer:
						'当前仅支持网页投保，小程序投保功能正在开发中，敬请期待。请上传身份证识别录入被保障人员信息。仅支持微信/支付宝扫码支付。',
				},
				{
					question: '保单和发票如何获取？',
					answer: '线上投保完成后实时出具电子保单及发票。本保险仅出具电子普票，不支持开具“增值税专用发票“，请知悉。',
				},
				{
					question: '哪些职业不保？',
					answer:
						'石材加工制造、矿业、采石业、炸药业、危险化工行业、直升机飞行人、飞行训练人、楼宇拆除工人爆破工作人员、潜水工作人员、火药、炸药制造人员、有关高压电工作人员、石棉瓦工作人员、特技演员、驯兽师、空中飞人、走钢丝人员、动物园驯兽师、保镖、炸药处理警察、防爆警察、警校学生、拳击运动员、各类赛车手、跳伞、登山运动人员、现役军人、煤矿业、油矿业。',
				},
				{
					question: '什么是高处作业？',
					answer:
						'高处作业以《高处作业分级标准》(中华人民共和国国家标准GB/T3608-2008)中的定义为准：“凡在坠落高度基准面2m以上(含2m)有可能坠落的高处进行的作业”。',
				},
				{
					question: '如果从事高处作业，但是没有高处作业证，保险公司是否拒赔？',
					answer:
						'不会拒赔。若从事高处作业未取得由应急管理部门颁发《高处作业操作证》，发生死亡或伤残事故，保险人按照保单约定应承担保险责任的75%计算赔偿金额。',
				},
				{
					question: '本保险是否要求特种作业证？',
					answer:
						'被保险人如系涉及特种行业岗位，根据《中华人民共和国安全生产法》之规定，必须持有国家安全生产监管局签发的特种作业操作证（不含高处作业操作证）或国家质量技术监督局签发的特种设备作业证上岗，否则本保险公司对可能发生的人身伤亡及医疗费用不承担赔偿责任。',
				},
				{
					question: '本保险对于医院的要求是怎样的？',
					answer:
						'本保险意外医疗相关保障指定就诊医院为中华人民共和国境内(不包括香港、澳门、台湾地区)<span class="red-bold">二级或二级以上公立医院</span>，且应符合下列所有条件：\n' +
						'（1）拥有合法经营执照；\n' +
						'（2）设立的主要目的为向受伤者和患病者提供留院治疗和护理服务；\n' +
						'（3）有合格的医生和护士提供全日二十四小时的医疗和护理服务；\n' +
						'（4）非主要作为康复医院、诊所、护理、疗养、戒酒、戒毒或类似的医疗机构。但不包括以下医院：北京市的平谷区、密云区、怀柔区所有医院；江苏省的徐州市、南通市、连云港市所有医院；天津市的滨海、静海地区所有医院；辽宁省的铁岭市所有医院、辽宁中医药大学附属第二医院、中国人民解放军第二0五医院、辽宁省中医医院、营口市所有医院；吉林省的长春市、四平市所有医院、吉林省中医医院、吉林通化市人民医院、抚松县中医院；黑龙江省佳木斯市富锦市中心医院、中医医院、鸡西市所有医院；河北省的青县、青龙县、东光县、三河市、承德市兴隆县、廊坊市固安县所有医院、邯郸市馆陶县人民医院、南皮县中医医院；河南省的信阳市、洛阳市、郑州市、开封市、新乡市、商丘市、焦作市、安阳市黄县所有医院、通许县中医院；山东省的禹城市、栖霞市、莱州市、德州禹城、潍坊市高密县的所有医院、滨州市中心医院、青岛市即墨区中医医院、莱阳市中医医院、济宁市金乡县人民医院、鱼台县人民医院、荣成市中医院、烟台市中医院、富顺县中医院、曹县人民医院、济南市长清区人民医院；山西省运城市、阳泉市所有医院、太原市迎泽区中医院；四川省的宜宾市、内江市、雅安市所有医院、邛崃市医疗中心医院；内蒙古的扎兰屯市、赤峰市所有医院；广东省的湛江市第二中医医院、茂名市电白区人民医院；湖南省的衡阳市中医正骨医院、衡阳市中心医院；安徽省毫州市所有医院；甘肃省民勤县人民医院、庆阳市中医医院；福建南平的所有医院；所有私营社保定点医院。请注意：被保险人在上述医院进行治疗的，保险人均不予以理赔，建议您去其他区域的<span class="red-bold">二级或二级以上公立医院</span>就医。',
				},
			],
			isDownLoading: false,
			dataBenefit: [
				{
					levelItem: '比例',
					level10: '5%',
					level9: '7%',
					level8: '15%',
					level7: '20%',
					level6: '30%',
					level5: '40%',
					level4: '60%',
					level3: '70%',
					level2: '80%',
					level1: '100%',
				},
			],
		}
	},
	created() {},
	methods: {
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 2 || rowIndex === 4) {
				if (columnIndex === 1) {
					return [1, 4]
				}
			}

			if (columnIndex === 0) {
				if (rowIndex === 1 || rowIndex === 3) {
					return {
						rowspan: 2,
						colspan: 1,
					}
				} else if (rowIndex === 2 || rowIndex === 4) {
					return {
						rowspan: 0,
						colspan: 0,
					}
				}
			}
		},
		handleInsure() {
			this.$emit('insure')
		},
		handleDownLoad() {
			this.isDownLoading = true
			let fileName = `tk_${this.productId}_template_chinalife_${currentYYYYmmdd()}.xlsx`
			handleDownCategoryFile(
				`/dist/distInsure/categoryDownloadDetail
/${this.productId}`,
				{},
				fileName,
			)
				.then(() => {
					//下载成功
				})
				.finally(() => {
					this.isDownLoading = false
				})
		},
	},
}
</script>

<style lang="scss" scoped>
.red-bold {
	color: red;
	font-weight: bold;
}

.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}

h2 {
	margin: 0px;
	padding: 0px;
}
</style>
